import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { useStyles } from './style';
import clsx from 'clsx';
import sortBy from 'lodash/sortBy';
import { PaginationComponenets, CheckboxComponent, Icons, NewLoading } from 'components';
const TableComponents = forwardRef((props, ref) => {
  const {
    data,
    columns,
    selectionOptions = { hasCheckbox: false, seletedCheckData: [] },
    checkBoxAction,
    showPagination = true,
    actions,
    isLoading,
    onChange = () => { },
  } = props;

  const classes = useStyles();
  const [dataItem, setDataItem] = useState([]); // استوریج مربوط به دیتا که ذخیره میشود
  const [currentPage, setCurrentPage] = useState(1); // استیت شماره صفحه جاری را ذخیره میکند
  const [itemsPerPage, setItemsPerPage] = useState(10); // شماره صفحه بندی را از PAGINATION میگیرید
  const [totalItems, setTotalItems] = useState(0); // تعداد کل ردیف دیتا رو دارا میباشد
  const [hasData, setHasData] = useState(false); //  یک کلید برای جلوگیری از کال شدن  چندین درخواست
  const [columnSorted, setColumnSorted] = useState([]); // دیتای جدول سورت شده
  const [checkedRows, setCheckedRows] = useState([]);
  const [allCheck, setAllCheck] = useState(false);
  const { hasCheckbox, seletedCheckData } = selectionOptions;

  useEffect(() => {
    if (!dataItem?.length) {
      getData(); // تابع مربوط به دریافت لیست کل جدول صفحه جاری از والد
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (hasCheckbox) seletedCheckData(checkedRows);
    }, 1000);
  }, [checkedRows]);

  // این تابع تمامی checkbox ها را انتخاب و یا از حالت انتخاب خارج میکند
  const toggleAllCheckboxes = (isCheck) => {
    if (isCheck) {
      const allIds = dataItem.map((order) => order);
      setCheckedRows(allIds);
      setAllCheck(true);
    } else {
      setCheckedRows([]);
      setAllCheck(false);
    }
  };

  // این تابع برای انتخاب checkbox
  const addWithCheckBox = (row, isCheck) => {
    if (isCheck) {
      setCheckedRows([...checkedRows, row]);
    } else {
      if (row?.id) {
        setCheckedRows(checkedRows.filter((data) => data.id !== row.id));
      } else {
        setCheckedRows(checkedRows.filter((data) => data.num !== row.num));
      }

      //اگر آخرین چک باکس از حالت چک خارج شود در صورتی که بر روی کلید همه چک باکس زده شده باشد از حالت چک خارج میشود
      if (checkedRows.length === 1) {
        setCheckedRows([]);
        setAllCheck(false);
      }
    }
  };

  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const handlePageChange = async (param) => {
    // تابع مربوط به تغییر در صفحه بندی و تعداد صفحات در کامپوننت فرزند
    // شرط مربوط به اگر کاربر کامپوننت فرزند و تغییراتی لحاظ کرد موارد مربوط به این تایبع فراخوانی میشود ( جهت جلوگیری از کال شدن چندین بار درخواست)
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میشه
      await setAllCheck(true);
      setCheckedRows([]);
      setTimeout(async () => {
        await setAllCheck(false);
      }, 1);
      setCurrentPage(param?.page == 0 ? 1 : param?.page);
      let dataPromise = await onChange?.(param);
      setItemsPerPage(param?.pageSize);
      setDataItem(dataPromise?.data);
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  //این متد برای تغییرات روی هر رکورد مورد استفاده قرار میگیرد ، با این روش که با استفاده از ref میتوان تغییرات مربوط به سرویس پرنت و با با کال کردن سرویس getdata مورد استفاده قرار میگیرد
  useImperativeHandle(ref, () => ({
    onChangeTable(isFilter) {
      setAllCheck(true);
      setCheckedRows([]);
      setTimeout(async () => {
        await setAllCheck(false);
      }, 1);
      if (isFilter) {
        setItemsPerPage(10);
        setCurrentPage(1);
      }
      getData(true);
    },
    refreshRows(options) {
      return getData(true, options);
    },
  }));

  const getData = async (status = false, mergeOptions = null) => {
    if (!hasData || status) {
      let dataPromise = await data();
      let result = columns.map((d) => {
        return { ...d, sort: 'asc' };
      });
      setColumnSorted(result);
      setTotalItems(dataPromise?.totalCount);
      if (mergeOptions?.rowKey) {
        const incomingRows = dataPromise?.data || [];
        const incomingRowsByKey = new Map(
          incomingRows.map((row) => [row?.[mergeOptions.rowKey], row]),
        );

        setDataItem((currentRows) => {
          let hasChangedRow = false;
          const mergedRows = currentRows.map((currentRow) => {
            const incomingRow = incomingRowsByKey.get(currentRow?.[mergeOptions.rowKey]);
            if (!incomingRow) return currentRow;

            const compareFields = mergeOptions.compareFields || Object.keys(incomingRow);
            const hasChanged = compareFields.some(
              (field) => currentRow?.[field] !== incomingRow?.[field],
            );

            if (!hasChanged) return currentRow;

            hasChangedRow = true;
            return mergeOptions.highlightUpdatedRows
              ? { ...incomingRow, __tableRowUpdatedAt: Date.now() }
              : incomingRow;
          });

          return hasChangedRow ? mergedRows : currentRows;
        });
      } else {
        setDataItem(dataPromise?.data);
      }
      setHasData(true);
    }

    // setCheckedRows([])
    // setTimeout(async () => {
    //     await setAllCheck(false)
    // }, 10)
  };

  // این تابع عملیات سورت روی ستون ها رو فراهم میکند
  const sortColumn = (field, index, isSort) => {
    if (isSort) {
      if (columnSorted[index]?.sort === 'asc') {
        columnSorted[index].sort = 'desc';
        setDataItem(_.sortBy(dataItem, field));
      } else {
        columnSorted[index].sort = 'asc';
        sortBy(dataItem, 'name');
        setDataItem(_.sortBy(dataItem, field).reverse());
      }
    }
  };
  return (
    <>
      <div className={classes.componenetTable}>
        {isLoading && <NewLoading type="table" />}
        {checkedRows && checkedRows?.length > 0 && (
          <div className={classes.actionCheckbox}>
            <>
              <div className={classes.selectRow}> {checkedRows?.length} سطر انتخاب شده </div>
              {checkBoxAction.map((action, actionIndex) => {
                const actionProps = action(actionIndex);
                return <React.Fragment key={actionIndex}>{actionProps.icon()}</React.Fragment>;
              })}
            </>
          </div>
        )}
        <div className={classes.tableBlocK}>
          <table className={classes.table}>
            <thead className={clsx(dataItem?.length !== 0 ? classes.thead : classes.emptyHead)}>
              <tr className={classes.tr}>
                {hasCheckbox && dataItem?.length > 0 && (
                  <th className={classes.th} style={{ width: '30px' }}>
                    <CheckboxComponent
                      onChange={(e) => toggleAllCheckboxes(e)}
                      checkForce={allCheck}
                    />
                  </th>
                )}

                {columnSorted.map((row, index) => (
                  <th
                    className={clsx(
                      row.sort === 'asc' ? classes.desc : classes.th,
                      row.field === 'operation'
                        ? 'operation'
                        : row.field === 'operationFull'
                          ? 'operationFull'
                          : row.field === 'operationSmall'
                            ? 'operationSmall'
                            : '',
                      row.field === 'num' ? 'num' : 'th',
                      classes.th,
                    )}
                  >
                    {row?.sorting && (
                      <img
                        alt="Sort Table"
                        className={classes.sort}
                        src="./images/sortTable.svg"
                        style={{ cursor: row?.sorting ? 'pointer' : '' }}
                      />
                    )}
                    <span
                      style={{ cursor: row?.sorting ? 'pointer' : '' }}
                      onClick={() => sortColumn(row.field, index, row?.sorting)}
                    >
                      {row.title}
                    </span>
                  </th>
                ))}
                {actions && actions?.length > 0 && dataItem?.length > 0 && (
                  <th className={classes.th} style={{ width: '60px' }}>
                    {' '}
                    عملیات
                  </th>
                )}
              </tr>
            </thead>
            {dataItem?.length === 0 && isLoading && (
              <tbody className={classes.emptyLoading}></tbody>
            )}
            {dataItem?.length !== 0 ? (
              <tbody className={classes.tbody}>
                {dataItem &&
                  dataItem.map((row, index) => (
                    <tr
                      key={
                        row?.__tableRowUpdatedAt
                          ? `${index}-${row.__tableRowUpdatedAt}`
                          : index
                      }
                      className={clsx(
                        classes.tr,
                        row?.__tableRowUpdatedAt && classes.updatedRow,
                      )}
                    >
                      {hasCheckbox && (
                        <td className={classes.td} style={{ width: '30px' }}>
                          <CheckboxComponent
                            onChange={(e) => addWithCheckBox(row, e)}
                            checkForce={allCheck}
                          />
                        </td>
                      )}
                      {columnSorted &&
                        columnSorted.map((item, i) => (
                          <td
                            style={{ direction: item.dir ? item.dir : '' }}
                            className={clsx(
                              classes.td,
                              item.field === 'operation'
                                ? 'operation'
                                : item.field === 'operationFull'
                                  ? 'operationFull'
                                  : item.field === 'operationSmall'
                                    ? 'operationSmall'
                                    : '',
                              item.field === 'num' ? 'num' : '',
                            )}
                          >
                            {item.render ? item.render(row) : row[item.field]}
                          </td>
                        ))}
                      {actions && actions?.length > 0 && (
                        <td className={classes.td} style={{ width: '60px', direction: 'rtl' }}>
                          {actions.map((action, actionIndex) => {
                            const actionProps = action(row);
                            return (
                              <React.Fragment key={actionIndex}>
                                {actionProps.icon()}
                              </React.Fragment>
                            );
                          })}
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            ) : (
              isLoading === false && (
                <tbody className={classes.notFoundBlock}>
                  <tr className={classes.notFound}>
                    <div className={classes.icon}>
                      <Icons icon="FolderError" color="#303d8f" size="45" />
                    </div>
                    <p>موردی یافت نشد</p>
                  </tr>
                </tbody>
              )
            )}
          </table>
        </div>
        <div className={clsx(dataItem?.length === 0 ? classes.emptyTable : classes.pagination)}>
          {showPagination && !isLoading && dataItem?.length !== 0 && (
            // کامپوننت صفحه بندی جدول
            <PaginationComponenets
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              pageCount={totalItems}
              onChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </>
  );
});

export default TableComponents;

